module.exports = __webpack_public_path__ + "media/images/athletes/2605-6cdbb69865a9c65aa6463fe39e40fed3.png";